import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Plans = () => {
  const [selectedPlan, setSelectedPlan] = useState(null);

  const incomeStreams = [
    {
      id: 1,
      title: 'Direct Sponsor Bonus',
      icon: '🎯',
      percentage: '15%',
      description: 'Earn 15% commission on every direct referral\'s product purchase',
      example: 'When your referral buys products worth ₹10,000, you earn ₹1,500',
      color: 'bg-blue-500'
    },
    {
      id: 2,
      title: 'Level Income',
      icon: '📊',
      percentage: '15 Levels',
      description: 'Earn from your network up to 15 levels with decreasing percentages',
      example: 'Level 1: 10%, Level 2: 5%, Level 3: 3%... up to Level 15: 0.5%',
      color: 'bg-green-500'
    },
    {
      id: 3,
      title: 'Monthly Product Rewards',
      icon: '🎁',
      percentage: 'Upto ₹6000',
      description: 'Get monthly rewards based on your total product purchases',
      example: '₹6,000 purchase → ₹1,000/month for 6 months',
      color: 'bg-purple-500'
    },
    {
      id: 4,
      title: 'Daily Boosting Income',
      icon: '🚀',
      percentage: '10%',
      description: 'Top 3 daily performers get extra bonuses',
      example: '1st: 10%, 2nd: 5%, 3rd: 3% of daily business',
      color: 'bg-orange-500'
    },
    {
      id: 5,
      title: 'Real-Time Bonanza',
      icon: '🎉',
      percentage: '1 Lac',
      description: 'Exponential growth rewards for network builders',
      example: '10×100×1000×10000×100000 = ₹1 Lac per level',
      color: 'bg-red-500'
    },
    {
      id: 6,
      title: 'Lifetime Rewards',
      icon: '🏆',
      percentage: '50 Cr',
      description: 'One-time rewards when you achieve new ranks',
      example: 'Director Club rank: ₹50 Cr reward',
      color: 'bg-yellow-500'
    },
    {
      id: 7,
      title: 'Royalty Club',
      icon: '🚗',
      percentage: 'Fortuner',
      description: 'Car rewards for top rank holders',
      example: 'Fortuner: ₹1 Lac/month for 51 months',
      color: 'bg-indigo-500'
    }
  ];

  const ranks = [
    { name: 'STAR', business: '1 Lac', reward: '₹5,000', color: 'bg-gray-400' },
    { name: 'SILVER STAR', business: '2.5 Lacs', reward: '₹12,500', color: 'bg-gray-500' },
    { name: 'GOLD', business: '5 Lacs', reward: '₹25,000', color: 'bg-yellow-600' },
    { name: 'PLATINUM', business: '10 Lacs', reward: '₹50,000', color: 'bg-gray-600' },
    { name: 'DIAMOND', business: '25 Lacs', reward: '₹1.25 Lacs', color: 'bg-blue-600' },
    { name: 'BLUE DIAMOND', business: '50 Lacs', reward: '₹2.5 Lacs', color: 'bg-blue-800' },
    { name: 'ROYAL DIAMOND', business: '1 Cr', reward: '₹5 Lacs', color: 'bg-purple-600' },
    { name: 'CROWN DIAMOND', business: '2 Cr', reward: '₹10 Lacs', color: 'bg-purple-800' },
    { name: 'CROWN AMBASSADOR', business: '5 Cr', reward: '₹25 Lacs', color: 'bg-red-600' },
    { name: 'DOUBLE CROWN STAR', business: '15 Cr', reward: '₹75 Lacs', color: 'bg-red-800' },
    { name: 'DIRECTOR STAR', business: '100 Cr', reward: '₹5 Cr', color: 'bg-yellow-700' },
    { name: 'DIRECTOR CLUB', business: '1000 Cr', reward: '₹25 Cr', color: 'bg-yellow-900' }
  ];

  const monthlyRewards = [
    { purchase: '₹6,000', reward: '₹1,000', months: '3 months' },
    { purchase: '₹10,000', reward: '₹6,000', months: '6 months' },
    { purchase: '₹15,000', reward: '₹1,000', months: '3 months' },
    { purchase: '₹25,000', reward: '₹3,000', months: '3 months' },
    { purchase: '₹50,000', reward: '₹5,000', months: '3 months' },
    { purchase: '₹1,00,000', reward: '₹6,000', months: '6 months' }
  ];

  const levelPercentages = [
    { level: 1, percentage: '10%' },
    { level: 2, percentage: '5%' },
    { level: 3, percentage: '3%' },
    { level: 4, percentage: '2.5%' },
    { level: 5, percentage: '1.5%' },
    { level: 6, percentage: '1.5%' },
    { level: 7, percentage: '1%' },
    { level: 8, percentage: '1%' },
    { level: 9, percentage: '1%' },
    { level: 10, percentage: '0.5%' },
    { level: 11, percentage: '0.5%' },
    { level: 12, percentage: '0.5%' },
    { level: 13, percentage: '0.5%' },
    { level: 14, percentage: '0.5%' },
    { level: 15, percentage: '0.5%' }
  ];

  const charges = [
    // { type: 'Service Charge', percentage: '10%', description: 'For platform maintenance and support' },
    { type: 'TDS Deduction', percentage: '5%', description: 'Tax deduction at source as per government norms' },
    { type: 'Admin Charge', percentage: '5%', description: 'For administrative and processing fees' }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-primary to-secondary text-white py-16">
        <div className="max-w-7xl mx-auto px-5 text-center">
          <h1 className="text-4xl font-bold mb-4">Our Marketing Plan</h1>
          <p className="text-xl text-gray-100">
            7 Types of Income • Unlimited Earning Potential • Financial Freedom
          </p>
        </div>
      </section>

      {/* How to Join */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-5">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-secondary mb-4">How To Join Us</h2>
            <p className="text-xl text-gray-600">Simple 3-step process to start your journey</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-primary rounded-full flex items-center justify-center text-white text-3xl font-bold mx-auto mb-4">
                1
              </div>
              <h3 className="text-xl font-bold text-secondary mb-2">Purchase Product</h3>
              <p className="text-gray-600">Buy any product worth ₹310 or more to start your business</p>
            </div>
            
            <div className="text-center">
              <div className="w-20 h-20 bg-primary rounded-full flex items-center justify-center text-white text-3xl font-bold mx-auto mb-4">
                2
              </div>
              <h3 className="text-xl font-bold text-secondary mb-2">Complete Registration</h3>
              <p className="text-gray-600">Fill in your details and get your unique ID</p>
            </div>
            
            <div className="text-center">
              <div className="w-20 h-20 bg-primary rounded-full flex items-center justify-center text-white text-3xl font-bold mx-auto mb-4">
                3
              </div>
              <h3 className="text-xl font-bold text-secondary mb-2">Start Earning</h3>
              <p className="text-gray-600">Build your network and earn through 7 income streams</p>
            </div>
          </div>
        </div>
      </section>

      {/* Income Streams */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-5">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-secondary mb-4">7 Types of Income</h2>
            <p className="text-xl text-gray-600">Multiple ways to earn and grow your income</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {incomeStreams.map((stream) => (
              <div
                key={stream.id}
                className={`bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow cursor-pointer border-2 border-transparent hover:border-primary`}
                onClick={() => setSelectedPlan(stream)}
              >
                <div className="flex items-center mb-4">
                  <div className={`w-12 h-12 ${stream.color} rounded-full flex items-center justify-center text-white text-xl mr-3`}>
                    {stream.icon}
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-secondary">{stream.title}</h3>
                    <span className="text-primary font-bold">{stream.percentage}</span>
                  </div>
                </div>
                <p className="text-gray-600 mb-3">{stream.description}</p>
                <div className="bg-gray-50 rounded p-3">
                  <p className="text-sm text-gray-700">
                    <strong>Example:</strong> {stream.example}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Detailed Plan Modal */}
      {selectedPlan && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg max-w-2xl w-full max-h-screen overflow-y-auto">
            <div className="p-6">
              <div className="flex justify-between items-start mb-4">
                <div className="flex items-center">
                  <div className={`w-16 h-16 ${selectedPlan.color} rounded-full flex items-center justify-center text-white text-2xl mr-4`}>
                    {selectedPlan.icon}
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-secondary">{selectedPlan.title}</h3>
                    <span className="text-primary font-bold text-lg">{selectedPlan.percentage}</span>
                  </div>
                </div>
                <button
                  onClick={() => setSelectedPlan(null)}
                  className="text-gray-500 hover:text-gray-700 text-2xl"
                >
                  ×
                </button>
              </div>
              
              <div className="space-y-4">
                <p className="text-gray-700">{selectedPlan.description}</p>
                <div className="bg-blue-50 rounded-lg p-4">
                  <h4 className="font-bold text-blue-800 mb-2">How it works:</h4>
                  <p className="text-blue-700">{selectedPlan.example}</p>
                </div>
                
                {selectedPlan.id === 2 && (
                  <div className="bg-green-50 rounded-lg p-4">
                    <h4 className="font-bold text-green-800 mb-2">Level Breakdown:</h4>
                    <div className="grid grid-cols-3 gap-2">
                      {levelPercentages.slice(0, 9).map((level) => (
                        <div key={level.level} className="text-sm">
                          <span className="font-bold">Level {level.level}:</span> {level.percentage}
                        </div>
                      ))}
                    </div>
                    <div className="grid grid-cols-3 gap-2 mt-2">
                      {levelPercentages.slice(9).map((level) => (
                        <div key={level.level} className="text-sm">
                          <span className="font-bold">Level {level.level}:</span> {level.percentage}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                
                {selectedPlan.id === 3 && (
                  <div className="bg-purple-50 rounded-lg p-4">
                    <h4 className="font-bold text-purple-800 mb-2">Monthly Reward Tiers:</h4>
                    <div className="space-y-2">
                      {monthlyRewards.map((reward, index) => (
                        <div key={index} className="flex justify-between text-sm">
                          <span>Purchase: {reward.purchase}</span>
                          <span>Reward: {reward.reward} for {reward.months}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
              
              <div className="mt-6 flex justify-end space-x-4">
                <button
                  onClick={() => setSelectedPlan(null)}
                  className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors"
                >
                  Close
                </button>
                <Link
                  to="/register"
                  onClick={() => setSelectedPlan(null)}
                  className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-dark transition-colors"
                >
                  Join Now
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Rank System */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-5">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-secondary mb-4">Rank Progression System</h2>
            <p className="text-xl text-gray-600">Climb the ladder of success with lifetime rewards</p>
          </div>
          
          <div className="overflow-x-auto">
            <table className="w-full bg-white rounded-lg shadow-lg overflow-hidden">
              <thead className="bg-primary text-white">
                <tr>
                  <th className="px-6 py-3 text-left">Rank</th>
                  <th className="px-6 py-3 text-left">Business Required</th>
                  <th className="px-6 py-3 text-left">Lifetime Reward</th>
                  <th className="px-6 py-3 text-left">Status</th>
                </tr>
              </thead>
              <tbody>
                {ranks.map((rank, index) => (
                  <tr key={index} className="border-b border-gray-200 hover:bg-gray-50">
                    <td className="px-6 py-4">
                      <div className="flex items-center">
                        <div className={`w-3 h-3 ${rank.color} rounded-full mr-3`}></div>
                        <span className="font-bold">{rank.name}</span>
                      </div>
                    </td>
                    <td className="px-6 py-4">{rank.business}</td>
                    <td className="px-6 py-4 font-bold text-primary">{rank.reward}</td>
                    <td className="px-6 py-4">
                      <span className="px-2 py-1 bg-green-100 text-green-800 rounded text-sm">
                        Active
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* Charges & Deductions */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-5">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-secondary mb-4">Charges & Deductions</h2>
            <p className="text-xl text-gray-600">Transparent fee structure for all transactions</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {charges.map((charge, index) => (
              <div key={index} className="bg-white rounded-lg shadow-lg p-6 text-center">
                <div className="text-3xl font-bold text-primary mb-2">{charge.percentage}</div>
                <h3 className="text-xl font-bold text-secondary mb-2">{charge.type}</h3>
                <p className="text-gray-600">{charge.description}</p>
              </div>
            ))}
          </div>
          
          <div className="mt-8 bg-yellow-50 border border-yellow-200 rounded-lg p-6">
            <h3 className="text-lg font-bold text-yellow-800 mb-2">Important Notes:</h3>
            <ul className="space-y-2 text-yellow-700">
              {/* <li>• Total deductions: 20% (10% + 5% + 5%)</li> */}
              <li>• Minimum payout amount: ₹1,000</li>
              <li>• Closing dates: 1-15 (Payout on 20th), 16-30 (Payout on 5th)</li>
              <li>• 10 direct sponsors required for level income</li>
              <li>• Unlimited earning potential</li>
            </ul>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-r from-primary to-secondary text-white">
        <div className="max-w-7xl mx-auto px-5 text-center">
          <h2 className="text-4xl font-bold mb-4">Ready to Start Your Journey?</h2>
          <p className="text-xl mb-8">Join thousands who are already achieving financial freedom</p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/register"
              className="px-8 py-4 bg-yellow-400 text-gray-900 rounded-lg hover:bg-yellow-300 transition-colors font-bold text-lg"
            >
              Join Now - Just ₹310
            </Link>
            <Link
              to="/products"
              className="px-8 py-4 bg-transparent border-2 border-white text-white rounded-lg hover:bg-white hover:text-primary transition-colors font-bold text-lg"
            >
              View Products
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Plans;
